import {Injectable} from '@angular/core';
import {Http, Response, URLSearchParams, BaseRequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {Historique} from './historique.model';
import {DateUtils} from 'ng-jhipster';
import {User, UserService} from "../../shared";
import {IKeyedCollection} from "../../shared/util/ikeyedCollection";
import {KeyedCollection} from "../../shared/util/keyedCollection";


@Injectable()
export class HistoriqueService {

    private resourceUrl = 'api/historiques';

    constructor(private http: Http,
                private dateUtils: DateUtils,
                private userService: UserService) {
    }

    create(historique: Historique): Observable<Historique> {
        let copy: Historique = Object.assign({}, historique);
        copy.dateCreation = this.dateUtils.toDate(historique.dateCreation);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(historique: Historique): Observable<Historique> {
        let copy: Historique = Object.assign({}, historique);

        copy.dateCreation = this.dateUtils.toDate(historique.dateCreation);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<Historique> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            let jsonResponse = res.json();
            jsonResponse.dateCreation = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.dateCreation);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
            ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    public fillUser(listHistoriques: Historique[]) {
        if (listHistoriques != null) {
            let userDictionary: IKeyedCollection<Number> = new KeyedCollection<Number>();
            listHistoriques.forEach(historique => {
                if (historique.userId != null && !userDictionary.ContainsKey(historique.userId.toString())) {
                    userDictionary.Add(historique.userId.toString(), historique.userId);
                }
            })
            userDictionary.Values().forEach(userId => {
                this.userService.findById(userId).subscribe(user => {
                    if (user != null) {
                        listHistoriques.forEach(historique => {
                            if (historique.userId != null && historique.userId == user.id) {
                                historique.user = user;
                            }
                        });
                    }
                });
            });
        }
    }

    convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].dateCreation = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateCreation);
        }
        res._body = jsonResponse;
        return res;
    }

    private

    createRequestOption(req ?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('candidatureId', req.candidatureId);
            params.set('candidatureFormationId', req.candidatureFormationId);
            params.set('code', req.code);

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/historique/historique.service.ts